module.exports = {
  accepted: {
    key: 'accepted',
    label: 'Accepted',
  },
  declined: {
    key: 'declined',
    label: 'Declined',
  },
  tentative: {
    key: 'tentative',
    label: 'Tentative',
  },
  needsAction: {
    key: 'needsAction',
    label: 'Needs Action',
  },
};